import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import {
  rotaryDetailsFragment,
  rotaryFragment
} from "@saleor/fragments/rotary";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { Allvouchers } from "./types/AllVouchers";
import { RotaryDetails, RotaryDetailsVariables } from "./types/RotaryDetails";
import { RotaryList, RotaryListVariables } from "./types/RotaryList";

const rotaryList = gql`
  ${rotaryFragment}
  ${pageInfoFragment}
  query RotaryList(
    $filter: RotaryFilterInput
    $before: String
    $after: String
    $first: Int
    $last: Int
    $sort: RotarySortingInput
  ) {
    rotarys(
      filter: $filter
      before: $before
      after: $after
      first: $first
      last: $last
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          ...RotaryFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export const useRotaryListQuery = makeQuery<RotaryList, RotaryListVariables>(
  rotaryList
);

const rotaryDetails = gql`
  ${rotaryDetailsFragment}
  query RotaryDetails($id: ID!) {
    rotary(id: $id) {
      ...RotaryDetailsFragment
    }
  }
`;

export const useRotaryDetailsQuery = makeQuery<
  RotaryDetails,
  RotaryDetailsVariables
>(rotaryDetails);

export const allVouchers = gql`
  query Allvouchers {
    vouchersToNoShopAll {
      id
      name
      code
    }
  }
`;
export const useAllVouchersQuery = makeQuery<Allvouchers, null>(allVouchers);
